<script setup lang="ts">
import BaseSection from '@/application/shared/infrastructure/components/BaseSection.vue';
import { SENIOR_GET_QUOTE_URL } from '@hfc/ui-core';
import { useUrlHelper } from '@/shared/infrastructure/composition/useUrlHelper';
import { useMedicareConsentStore } from '@/consent/medicare/infrastructure/composition/useMedicareConsentStore';

const { medicareConsentState } = useMedicareConsentStore();
const { getBaseUrl } = useUrlHelper();

const title = medicareConsentState.value.application.appointment_required ? 'Your Appointment is Confirmed!' : 'Thank you for completing this disclosure.';
const subTitle = medicareConsentState.value.application.appointment_required ? 'A calendar invitation has been sent to your email address.' : 'Please call our office for quotes.';

</script>
<template>
  <BaseSection class="flex-1 items-center text-center">
    <div class="flex flex-col gap-4 lg:gap-6 flex-1 justify-center 2xl:pb-32">
      <hfc-icon :icon="['fa', 'calendar-day']" class="text-green-600 text-6xl" />
      <h1 class="text-center text-[3rem] mt-8">
        {{ title }}
      </h1>
      <div class="mt-5">
        <hr class="max-w-[50%] mx-auto">
        <p class="text-2xl py-5">
          {{ subTitle }}
        </p>
        <hr class="max-w-[50%] mx-auto">
      </div>
      <div class="flex justify-center">
        <div class="text-left pt-5">
          <strong>For more immediate service:</strong>
            <ul class="list-disc pl-10">
              <li>Call-<a href="tel:1-800-352-4784">1-800-352-4784</a></li>
              <li>Click here to <a :href="getBaseUrl(SENIOR_GET_QUOTE_URL)">Get a Quote Now</a></li>
            </ul>
        </div>
      </div>
    </div>
  </BaseSection>
</template>
